import { render } from "./About.vue?vue&type=template&id=49df64aa&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=49df64aa&scoped=true&lang=scss"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49df64aa"]])

export default __exports__